import React from 'react';
import { Box, useTheme } from '@mui/material';

interface StatusDotProps {
  status: 'success' | 'error' | 'warning' | 'pending' | 'inactive';
  size?: number;
}

export const StatusDot: React.FC<StatusDotProps> = ({ status, size = 3.5 }) => {
  const theme = useTheme();

  const getBackgroundColor = () => {
    switch (status) {
      case 'success':
        return theme.palette.success.main;
      case 'error':
        return theme.palette.error.main;
      case 'warning':
        return theme.palette.orange?.main || theme.palette.warning.main;
      case 'pending':
        return theme.palette.yellow?.main || theme.palette.warning.main;
      case 'inactive':
        return theme.palette.text.secondary;
      default:
        return theme.palette.success.main;
    }
  };

  const backgroundColor = getBackgroundColor();

  return (
    <Box
      sx={{
        width: theme.spacing(size),
        height: theme.spacing(size),
        borderRadius: theme.shape.borderRadius,
        backgroundColor,
      }}
    />
  );
};
